import React from 'react';
import { Link } from 'react-router-dom';
import './breadcrumb.css'


const Breadcrumb = (props)=>{
    const {product} = props;

    const occasion = ()=>{
        let test = (product.occasion).slice(0,1)
        return test
    }

    if(!product){
        return <div className='breadcrumb'>Loading...</div>;
    }

    return(
        <div className='breadcrumb'>
           <p><Link to='/'>Home</Link> {">"} <Link to={`/${occasion()}`}>{occasion()}</Link> {">"} {product.name}</p>
        </div>
    )
}

export default Breadcrumb